import Items from '../../components/molecules/providers/Items';
import CluesExplores from '../molecules/providers/CluesExplores';
import acHTTPClient from 'services/ACHTTPClient';
import config from 'config/config';
import { onAuthError } from 'components/common/auth';

const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getDefaultWhens = () => {
  return [
    {
      key: 'day',
      value: 'Monday',
    },
    {
      key: 'day',
      value: 'Tuesday',
    },
    {
      key: 'day',
      value: 'Wednesday',
    },
    {
      key: 'day',
      value: 'Thursday',
    },
    {
      key: 'day',
      value: 'Friday',
    },
    {
      key: 'day',
      value: 'Saturday',
    },
    {
      key: 'day',
      value: 'Sunday',
    },
  ];
};

const getDefaultProvider = () => {
  return {
    status: 'active',
    enablingStoryboard:false,
    POIs: [],
    whens: [],
    settings: { itemPaymentStatus: 'callToPay', itemActivityStatus: 'needsBooking' },
    uiElements: [{ type: 'callOut' }],
    media: { type: 'image', url: '' },
  };
};

const getDefaultPOI = () => {
  return {
    index: -1,
    category:"Unsorted",
    where: {
      address: undefined,
    },
    media: { type: 'image', url: '' },
  };
};

const getDefaultStoryboard = () => {
  return {
    status: 'active',
    uiElements: [{ type: 'callOut' }],
    media: { type: 'image', url: '' },
    pois :[],
  };
};

// TODO: DELETE EVERYTHING BELOW THISL LINE
const getProviderForms = () => {
  return {
    form1: {
      name: 'addprovider',
    },
    form2: {
      name: 'addclue',
    },
    form3: {
      name: 'addpoi',
    },
  };
};

const getProviderObjFromAPI = (providerFromAPI) => {
  let p = getDefaultProvider();

  p.id = providerFromAPI.id;
  p.providerName = providerFromAPI.name;
  p.suitables = providerFromAPI.suitables;
  p.whens = providerFromAPI.whens;
  p.contact = providerFromAPI.name;
  p.phone = providerFromAPI.phone;
  p.email = providerFromAPI.email;
  p.note = providerFromAPI.note;
  p.whens = providerFromAPI.whens;
  p.address = providerFromAPI.address;

  return p;
};

const getTabs = () => {
  return {
    items: {
      component: Items,
    },
    cluesAndExplorer: {
      component: CluesExplores,
    },
  };
};



async function fetchProviderList(filterParams, optLimit) {
    const limit = optLimit || 100;
    let apiURL = `${experienceAPIURL}/providers?limit=${limit}`;
    if (filterParams) {
      apiURL += '&' + filterParams.slice(1); // Remove extra & from the filter string
    }
              
    const config = { url: apiURL, method: 'GET' };
    return await acHTTPClient
    .request(config)
    .then(response => {
        if (!response.data || response.data.error) {
            return Promise.reject(response.statusText);
        }
        return response.data.data;
    })
    .catch(error => {
        onAuthError(error);
        return Promise.reject(error);
    });
}



export {
  getProviderForms,
  getDefaultPOI,
  getDefaultProvider,
  getDefaultWhens,
  getTabs,
  getProviderObjFromAPI,
  getDefaultStoryboard,
  fetchProviderList,
};
